import type { ParsedUrlQuery } from "node:querystring";
import { SearchQueryParams } from "src/components/pages/search/search.types";
import { ViewMode, TViewMode } from "src/components/pages/search/store/search-store";

export const mapViewToQuery = (view: TViewMode): string => (view === ViewMode.Table ? `${SearchQueryParams.View}=${view}` : "");

export const mapViewFromQuery = (urlParams: URLSearchParams): TViewMode | null => {
    const view = urlParams.get(SearchQueryParams.View);

    if (view === ViewMode.Grid || view === ViewMode.Table) {
        return view;
    }

    return null;
};

export const mapViewFromRouterQuery = (query: ParsedUrlQuery): TViewMode | null => {
    const value = query[SearchQueryParams.View];
    const view = Array.isArray(value) ? value[0] : value;

    if (view === ViewMode.Grid || view === ViewMode.Table) {
        return view;
    }

    return null;
};

export const getInitialViewFromRouterQuery = (query: ParsedUrlQuery): TViewMode => mapViewFromRouterQuery(query) ?? ViewMode.Grid;
